// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oU_f","right":"styles_right__2YgAj"};